import axios from "axios";
import { AIRequest, AIResponse } from "../types";

const API_URL = "https://groqprompt.netlify.app/api/ai";

export const fetchAIResponse = async (prompt: string): Promise<string> => {
  try {
    const payload: AIRequest = { prompt };
    const response = await axios.post<AIResponse>(API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data.result;
  } catch (error) {
    console.error("Lỗi khi gọi AI:", error);
    throw new Error("Không thể kết nối tới trợ lý AI. Vui lòng thử lại sau.");
  }
};
